import { ATTENDANCE_STATE_LABELS, type AttendanceState } from '@wodi/domain';
import type { LicenceStatusView } from '@wodi/shared';
import { Tag } from '@wodi/ui';

// Roster words (docs/plans/phase3-operations-modules.md §4.3). The licence warning is
// passive (plan R5): a tag beside the name, never a block.

export function LicenceWarning({ licence }: { licence: LicenceStatusView }) {
  if (licence.state === 'expired') return <Tag state="attention">Licence expired</Tag>;
  if (licence.state === 'expiring')
    return (
      <Tag state="attention">
        {licence.daysLeft === null || licence.daysLeft === 0
          ? 'Licence expires today'
          : `Licence expires in ${String(licence.daysLeft)} ${licence.daysLeft === 1 ? 'day' : 'days'}`}
      </Tag>
    );
  return null;
}

const STATE_TAG = {
  present: 'done',
  late: 'attention',
  left_early: 'attention',
  late_and_left_early: 'attention',
  absent: 'failed',
  not_yet: 'pending',
} as const satisfies Record<AttendanceState, string>;

export function AttendanceTag({ state }: { state: AttendanceState }) {
  return <Tag state={STATE_TAG[state]}>{ATTENDANCE_STATE_LABELS[state]}</Tag>;
}
